/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_JpegInputs */

const en_val_jpeg = /** @type {(inputs: Val_JpegInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JPEG`)
};

const es_val_jpeg = /** @type {(inputs: Val_JpegInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JPEG`)
};

const fr_val_jpeg = /** @type {(inputs: Val_JpegInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JPEG`)
};

const de_val_jpeg = /** @type {(inputs: Val_JpegInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JPEG`)
};

const ja_val_jpeg = /** @type {(inputs: Val_JpegInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JPEG`)
};

const zh_val_jpeg = /** @type {(inputs: Val_JpegInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JPEG`)
};

const ar_val_jpeg = /** @type {(inputs: Val_JpegInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JPEG`)
};

const id_val_jpeg = /** @type {(inputs: Val_JpegInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JPEG`)
};

const it_val_jpeg = /** @type {(inputs: Val_JpegInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JPEG`)
};

const ru_val_jpeg = /** @type {(inputs: Val_JpegInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JPEG`)
};

const pt_val_jpeg = /** @type {(inputs: Val_JpegInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JPEG`)
};

const ko_val_jpeg = /** @type {(inputs: Val_JpegInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JPEG`)
};

/**
* | output |
* | --- |
* | "JPEG" |
*
* @param {Val_JpegInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_jpeg = /** @type {((inputs?: Val_JpegInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_JpegInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_jpeg(inputs)
	if (locale === "es") return es_val_jpeg(inputs)
	if (locale === "fr") return fr_val_jpeg(inputs)
	if (locale === "de") return de_val_jpeg(inputs)
	if (locale === "ja") return ja_val_jpeg(inputs)
	if (locale === "zh") return zh_val_jpeg(inputs)
	if (locale === "ar") return ar_val_jpeg(inputs)
	if (locale === "id") return id_val_jpeg(inputs)
	if (locale === "it") return it_val_jpeg(inputs)
	if (locale === "ru") return ru_val_jpeg(inputs)
	if (locale === "pt") return pt_val_jpeg(inputs)
	return ko_val_jpeg(inputs)
});